module.exports = __webpack_public_path__ + "img/torino.11c8c2a5.png";